import { createSlice } from '@reduxjs/toolkit';

export type GlobalSliceType = {
  loading: boolean;
};
const initialState: GlobalSliceType = {
  loading: false
};

const userSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    globalLoading: (state) => {
      state.loading = true;
    },
    globalStopLoading: (state) => {
      state.loading = false;
    }
  }
});

export const { globalLoading, globalStopLoading } = userSlice.actions;

export default userSlice.reducer;
